
import { supportConnectDevice } from "../../../utils/device/deviceConnect";
import { getKooKongDeviceTypeByName } from "../../../utils/device/set/remote";
import { windVane } from '../../../utils/tmallGenius';
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'

export default {
components: { Cell, Group, },
data() {
return {
deviceList: []
};
},
beforeRouteEnter(to, from, next) {
next();
},
created() {
windVane.setNavTitle(this.$route.query.deviceName);
this.deviceList = supportConnectDevice.filter(
item => item.deviceGeneralType === "remote"
);
},
methods: {
/*------------------------------------------- 自定义方法 -------------------------------------------------------*/
/*------------------------------------------- 绑定方法 -------------------------------------------------------*/
/*  设置栏点击
* */
headerRightBtnClick() {
this.$router.push({
path: "/settings",
query: {
deviceId: this.$route.query.deviceId,
deviceGeneralType: this.$route.query.deviceGeneralType,
uid: this.$route.query.uid,
extraBackGo: 1,  //是内页
}
});
},
/*  设备点击，添加遥控
* */
panelClick(device) {
this.$router.push({
path: "/device/" + device.name + "/add",
query: {
uid: this.$route.query.uid,
kookongDeviceType: getKooKongDeviceTypeByName(device.name),
deviceId: this.$route.query.deviceId,
deviceType: device.deviceType,
aligenieZone: this.$route.query.aligenieZone,
}
}); //传递小方的设备信息，还有对应的酷控号码
}
}
};



// WEBPACK FOOTER //
// ./src/pages/device/xiaofang/Index.vue